let RenderingHandler = function (___settings, ___handlers) {
  const THREE = require('../../../../../externals/three'),
        ExpoTHREE = ___settings.externalLibraries.ExpoTHREE,
        AR = ___settings.externalLibraries.AR,
        GLOBAL_UTILS = require('../../../../../shared/util/GlobalUtils'),
        TO_TINY_COLOR = require('../../../../../shared/util/toTinyColor'),
        RenderingHandlerInterface = require('../../../../interfaces/handlers/RenderingHandlerInterface'),
        _settings = ___settings.settings,
        _scene = ___settings.scene,
        _container = ___settings.container,
        _handlers = ___handlers;

  let that,
      _width = _container.width,
      _height = _container.height,
      _renderer,
      _rendering = true,
      _hiddenRenderTarget,
      _updateShadowMap = true;

  ////////////
  ////////////
  //
  // the hooks for the settings go below
  //
  ////////////
  ////////////

  /**
   * Toggles the shadows.
   *
   * @param {Boolean} toggle To what to set the mode
   * @returns {Boolean} If the mode was successfully set
   */
  let _shadowsHook = function (toggle) {
    if (!GLOBAL_UTILS.typeCheck(toggle, 'boolean', _handlers.threeDManager.warn, 'RenderingHandler.Hook->shadows')) return false;
    _handlers.lightHandler.setToggleLightShadows(toggle);
    return true;
  };

  class RenderingHandler extends RenderingHandlerInterface {

    constructor() {
      super();
      that = this;
      _renderer = new ExpoTHREE.Renderer({gl: _container.gl, pixelRatio: _container.pixelRatio, width: _container.width, height: _container.height});

      _renderer.setSize(_width, _height);
      _renderer.setPixelRatio( window.devicePixelRatio );
      _renderer.gammaInput = true;
      _renderer.gammaOutput = true;
      _renderer.shadowMap.enabled = true;
      _renderer.shadowMap.autoUpdate = false;
      _renderer.shadowMap.needsUpdate = true;
      _renderer.physicallyCorrectLights = true;
      _renderer.toneMapping = THREE.ReinhardToneMapping;

      let _parameters = {
        minFilter: THREE.LinearFilter,
        magFilter: THREE.LinearFilter,
        format: THREE.RGBAFormat,
        stencilBuffer: false
      };
      
      _hiddenRenderTarget = new THREE.WebGLRenderTarget(_width, _height, _parameters);
      _hiddenRenderTarget.texture.name = 'hidden.rt';

      _settings.registerHook('shadows', _shadowsHook);
    }

    _getRenderer() {
      return _renderer;
    }

    ////////////
    ////////////
    //
    // RenderingHandler API
    //
    ////////////
    ////////////
    
    /** @inheritdoc */
    render(token) {
      // if(_renderer && _handlers.threeDManager)
      //   requestAnimationFrame(that.render);

      if(!_rendering) return;

      if(token !== 'expoRenderCall') return;

      // The viewport was just destroyed, this is the last render call
      if(!_handlers.threeDManager) return;

      // Don't render when the viewport should not be shown
      if (_handlers.threeDManager.getSettingShallow('show') === false) return;

      // Don't render if there is no camera
      if (!(_handlers.cameraHandler && _handlers.cameraHandler.getCamera())) return;

      if (_updateShadowMap == true) {
        _updateShadowMap = false;
        _renderer.shadowMap.needsUpdate = true;
      }

      _handlers.threeDManager.helpers.toggleViewport(true);
      _handlers.interactionHandler.update();
      _renderer.render(_scene, _handlers.cameraHandler.getCamera());
      _handlers.threeDManager.helpers.toggleViewport(false);
    }

    /** @inheritdoc */
    renderHidden() {
      // The viewport was just destroyed, this is the last render call
      if(!_handlers.threeDManager) return;

      // Don't render if there is no camera
      if (!(_handlers.cameraHandler && _handlers.cameraHandler.getCamera())) return;

      if (_updateShadowMap == true) {
        _updateShadowMap = false;
        _renderer.shadowMap.needsUpdate = true;
      }
       
      _handlers.threeDManager.helpers.toggleViewport(true);
      if(!_handlers.interactionHandler.isInitialized()) {
        _handlers.threeDManager.helpers.toggleGeometry(true);
        _handlers.threeDManager.helpers.toggleViewportObjects(true);
      }
      _renderer.render(_scene, _handlers.cameraHandler.getCamera(), _hiddenRenderTarget);
      if(!_handlers.interactionHandler.isInitialized()) {
        _handlers.threeDManager.helpers.toggleGeometry(false);
        _handlers.threeDManager.helpers.toggleViewportObjects(false);
      }
      _handlers.threeDManager.helpers.toggleViewport(false);
    }

    /** @inheritdoc */
    onResize(width, height, scale) {
      _renderer.setPixelRatio(scale);
      _renderer.setSize(width, height);
    }
    
    /** @inheritdoc */
    getSize() {
      return _renderer.getSize();
    }



    /** @inheritdoc */
    pause() {
      _rendering = false;
    }

    /** @inheritdoc */
    resume() {
      _rendering = true;
    }

    /** @inheritdoc */
    destroy() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }




    /** @inheritdoc */
    getScreenshot() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getDomElement() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getCanvas() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getRendererInfo() {
      return _renderer.info;
    }

    /** @inheritdoc */
    setBlur(blur, options) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }
    



    /** @inheritdoc */
    registerForNoRendering(id, rendering) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    unregisterForNoRendering(id) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    registerForRestrictedRendering(id, rendering) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    unregisterForRestrictedRendering(id) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    registerForContinuousRendering(id, rendering) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    unregisterForContinuousRendering(id) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    containsContinuousRendering(id) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }




    /** @inheritdoc */
    updateShadowMap() {
      _updateShadowMap = true;
    }

    /** @inheritdoc */
    keepUpdatingShadowMap() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    stopUpdatingShadowMap() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }
  }

  return new RenderingHandler();
};

module.exports = RenderingHandler;
